export default __webpack_public_path__ + "static/media/payment-qrcode.4c6f8ec3.png";